import React from 'react';

export const Circle = ({
    backgroundColor, height, width, x, y, margin,
}) => (
    <svg xmlns="http://www.w3.org/2000/svg" x={x} y={y} width={width} height={height} style={{ margin: `${margin}px` }} viewBox="0 0 438.533 438.533">
        <g>
            <path d="M409.133,109.203c-19.608-33.592-46.205-60.189-79.798-79.796C295.736,9.801,259.058,0,219.273,0   c-39.781,0-76.47,9.801-110.063,29.407c-33.595,19.604-60.192,46.201-79.8,79.796C9.801,142.8,0,179.489,0,219.267   c0,39.78,9.804,76.463,29.407,110.062c19.607,33.592,46.204,60.189,79.799,79.798c33.597,19.605,70.283,29.407,110.063,29.407   s76.47-9.802,110.065-29.407c33.593-19.602,60.189-46.206,79.795-79.798c19.603-33.596,29.403-70.284,29.403-110.062   C438.533,179.485,428.732,142.795,409.133,109.203z" fill={backgroundColor} />
        </g>
    </svg>
);

export default Circle;
